import React from "react"

//Utils
import { getServerAuthenticated } from "lib/utils/get-sever-authentication"

//Components
import Seo from "components/seo"
import Layout from "components/layout"
import LayoutGeneral from "components/layout-general-page"
import Helmet from "react-helmet"
import ConfirmPaymentComp from "components/pages/confirm-payment"
import { useRouter } from "next/router"
// import { useRouter } from "next/router"

const ConfirmPayment = () => {
  const Router = useRouter()
  return (
    <>
      <Seo title="Confirm Payment" />
      <Helmet>
        <body className="bd-confirm-payment" />
      </Helmet>
      <Layout>
        <ConfirmPaymentComp locale={Router.locale} />
      </Layout>
    </>
  )
}

export default ConfirmPayment
